import React from "react";
import { ComponentContainer } from "../styled.js";
import { ConcertsBg } from "../styled.js";
import { useLanguage } from "../i18n/LanguageContext";

const Concerts = () => {
  const { t } = useLanguage();

  const cityLabel = (city) => (t.concertCities[city] ? t.concertCities[city] : city);

  return (
    <div id="live">
      <ConcertsBg>
        <ComponentContainer>
          <br />
          <br />
          <h2>{t.concerts.heading}</h2>
          <table>
            <tbody>
              {t.concerts.rows.map((row) => {
                const venue = t.concertVenues[row.venueKey];
                const venueCell =
                  venue.url != null ? (
                    <a href={venue.url}>{venue.name}</a>
                  ) : (
                    venue.name
                  );
                return (
                  <tr key={`${row.date}-${row.venueKey}`}>
                    <td>{row.date}</td>
                    <td>{venueCell}</td>
                    <td>{cityLabel(row.city)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <br />
        </ComponentContainer>
      </ConcertsBg>
    </div>
  );
};

export default Concerts;
